import script from "./flash-growth-cadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./flash-growth-cadastro.vue?vue&type=script&setup=true&lang=js"

import "./flash-growth-cadastro.vue?vue&type=style&index=0&id=a374ff7e&lang=css"

const __exports__ = script;

export default __exports__